import React from 'react';
import Spinner from 'react-spinkit';

export const Loader = props => (
  <div className="w-100 d-flex justify-content-center">
    <Spinner name="circle" color="black" fadeIn="none" {...props} />
  </div>
);
